// tslint:disable:no-relative-imports
import { getBuildEnvVar, getRuntimeEnvVar } from '@wizbii/angular-utilities';
import { LangEnum, LocaleEnum } from '@wizbii/models';
import { buildConfig } from './build-config';

const packageJsonVersionAtBuild = require('../../package.json').version; // tslint:disable-line

// tslint:disable-next-line:ban-ts-ignore
// @ts-ignore
const production: boolean = buildConfig === 'production';
const applicationId = 'fibii';
const platform = getRuntimeEnvVar('PLATFORM', 'local');
const wizbiiDomain = getRuntimeEnvVar('WIZBII_ENV_FQDN');
const apiDomain = getRuntimeEnvVar('API_DOMAIN');
const apiPlatform = getRuntimeEnvVar('API_PLATFORM');

const algoliaAppId = getRuntimeEnvVar('ALGOLIA_APP_ID');
const algoliaApiKey = getRuntimeEnvVar('ALGOLIA_API_KEY');

const lang: keyof typeof LangEnum = getBuildEnvVar('LANG', 'fr');
const locale: keyof typeof LocaleEnum = getBuildEnvVar('LOCALE', 'fr_FR');

const deployAssetsUrl = production
  ? `https://storage.googleapis.com/wizbii-application-assets/fibii/${getBuildEnvVar('CI_COMMIT_SHA')}/fr/assets`
  : null;

export const environment = {
  applicationId,
  platform,
  production,
  appUrl: platform === 'local' ? `http://localhost:4200` : `https://money.${wizbiiDomain}`,
  cookieMoneyDomain: platform === 'local' ? 'localhost' : `.money.${wizbiiDomain}`,
  contactEmailKey: {
    base: 'money',
    premium: 'money_premium',
  },
  version: production ? packageJsonVersionAtBuild : getBuildEnvVar('GIT_BRANCH_NAME', 'next'),
  i18n: {
    lang: LangEnum[lang],
    locale: LocaleEnum[locale],
  },
  domain: {
    wizbii: wizbiiDomain,
  },
  api: {
    account: `https://account.api.${apiDomain}`,
    authentication: `https://auth.${apiDomain}`,
    contact: `https://contact.api.${apiDomain}`,
    content: `https://content-api.${apiDomain}`,
    domain: apiDomain,
    place: `https://place.${apiDomain}`,
    platform: apiPlatform,
    suggestion: `https://suggestion.api.${apiDomain}`,
    file: `https://file.${apiDomain}`,
    fibii: `https://fibii.api.${apiDomain}`,
    imaginary: `https://imaginary.${apiDomain}`,
    abtest: `https://abtest-api.${apiDomain}`,
  },
  urls: {
    account: {
      base: `https://account.${apiDomain}`,
      signIn: `https://account.${apiDomain}/sign-in?app-id=${applicationId}&redirect=`,
      signUp: `https://account.${apiDomain}/sign-up?app-id=${applicationId}&redirect=`,
      logout: `https://account.${apiDomain}/logout?app-id=${applicationId}&redirect=`,
    },
    googleStorage: 'https://storage.googleapis.com',
  },
  trackers: {
    gaConversionId: getRuntimeEnvVar('GOOGLE_ANALYTICS_CONVERSION_ID'),
    analyticsId: getRuntimeEnvVar('GOOGLE_ANALYTICS_UAI'),
    hotjar: { hjid: getRuntimeEnvVar('HOTJAR_ID'), hjsv: getRuntimeEnvVar('HOTJAR_VERSION') },
    delighted: getRuntimeEnvVar('DELIGHTED_ID'),
    facebook: {
      appId: getRuntimeEnvVar('FACEBOOK_PIXEL_ID'),
      version: getRuntimeEnvVar('FACEBOOK_PIXEL_VERSION'),
    },
    snapchat: { appId: getRuntimeEnvVar('SNAPCHAT_PIXEL_ID') },
    gtmId: getRuntimeEnvVar('GTM_ID'),
    tiktokId: getRuntimeEnvVar('TIKTOK_PIXEL_ID'),
    bingId: getRuntimeEnvVar('BING_PIXEL_ID'),
    timeone: {
      apiKey: '1da0421edbf788b3f7334b99f5562bb1',
      tipFirstId: '7727',
      tipSecondId: '1680231',
      timeOneId: '3517',
    },
  },
  bugsnag: {
    key: '9631b4ce2e6d998312ae665b965f891b',
  },
  stripe: {
    key: getRuntimeEnvVar('STRIPE_PUBLIC_KEY'),
  },
  deployAssetsUrl,
  suggestionSetId: getRuntimeEnvVar('SUGGESTION_SET_ID'),
  algolia: {
    applicationId: algoliaAppId,
    apiKey: algoliaApiKey,
    index: {
      faq: `${apiPlatform}_content_article_faq-fibii`,
      advices: `${apiPlatform}_content_article_wizbii-money`,
      advicesCategories: `${apiPlatform}_content_facet_wizbii-money_category`,
    },
  },
  wizbiiFiles: getRuntimeEnvVar('WIZBII_FILES_GCS_BUCKET'),
  abTest: {
    campaignId: 'beta-launch-08-21',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
if (!production) {
  import('zone.js/dist/zone-error' as any); // Included with Angular CLI.
}
